<template>
  <div>
    <div class="control-section dashboard-api" id="dashboard-control-section">
      <div class="content-wrapper" style="max-width:100%">
        <DPEnvironmentPanel ref="dpPanel" ></DPEnvironmentPanel>
      </div>
    </div>
  </div>
</template>


<script>
import DPEnvironmentPanel from '../../../components/deploymentManagement/runningEnvironment/DPEnviromentConfig/DPEnvironmentPanel';

export default {
  name: 'DPEnvironment',
  data() {
    return {
      widthNum: 3,
      spacing: 0
    };
  },
  components: {
    DPEnvironmentPanel
  }
};
</script>
